import React, { useState, useEffect } from 'react'
import Menu from './mechanic/components/menu'
import LoginForm from './mechanic/layouts/login-layout'
import areCredentialsValid from './mechanic/api/authentication-utils'
import { ROOT_PATH, LOGIN_PATH, CONFIGURATIONS_PATH, VERSIONS_PATH } from './mechanic/config/routes/paths'
import { Redirect, Route, Switch, HashRouter } from 'react-router-dom'
import PublicRoute from './mechanic/config/routes/public-routes'
import PrivateRoute from './mechanic/config/routes/private-routes'
import ConfigurationsPage from './mechanic/pages/configurations-page'
import VersionsPage from './mechanic/pages/versions-page'

function App () {
  const [authLoading, setAuthLoading] = useState(true)
  const [validCredentials, setValidCredentials] = useState(false)

  useEffect(() => {
    if (authLoading) {
      areCredentialsValid().then((response) => {
        setValidCredentials(response && response.status === 200)
        setAuthLoading(false)
      }).catch(() => {
        setAuthLoading(false)
      })
    }
  })

  if (authLoading) {
    return <div className='content'>Checking credentials...</div>
  }

  const isAuthenticated = validCredentials
  return (
    <HashRouter basename='/projects/mechanic'>
      <Menu isAuthenticated={isAuthenticated} />
      <Switch>
        <Route exact path={ROOT_PATH} component={() => <Redirect to={CONFIGURATIONS_PATH} />} />
        <PublicRoute path={LOGIN_PATH} component={() => <LoginForm setAuthLoading={setAuthLoading} />} isAuthenticated={isAuthenticated} />
        <PrivateRoute path={CONFIGURATIONS_PATH} component={ConfigurationsPage} isAuthenticated={isAuthenticated} />
        <PrivateRoute path={VERSIONS_PATH} component={VersionsPage} isAuthenticated={isAuthenticated} />
      </Switch>
    </HashRouter>
  )
}

export default App
